export const CATEGORY_IMAGES = {
  truck: {
    url: 'https://images.unsplash.com/photo-1766785286781-d3a0e20f6d7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB0cnVjayUyMGZsZWV0JTIwaGlnaHdheSUyMGRheWxpZ2h0fGVufDB8fHx8MTc3NzYyMzI3Mnww&ixlib=rb-4.1.0&q=85',
    alt: 'Modern prime mover travelling on open highway for truck and trailer finance context',
  },
  equipment: {
    url: 'https://images.unsplash.com/photo-1664312616511-81fe2e745cb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBleGNhdmF0b3IlMjB3b3Jrc2l0ZXxlbnwwfHx8fDE3Nzc2MjI1MDd8MA&ixlib=rb-4.1.0&q=85',
    alt: 'Construction excavator at worksite representing equipment finance demand',
  },
  vehicle: {
    url: 'https://images.unsplash.com/photo-1775865937358-c7d2972e78ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxmbGVldCUyMHZhbnMlMjBidXNpbmVzcyUyMHZlaGljbGVzfGVufDB8fHx8MTc3NzYyMjUwN3ww&ixlib=rb-4.1.0&q=85',
    alt: 'Business van fleet parked and ready for commercial operations',
  },
  business: {
    url: 'https://images.unsplash.com/photo-1714974528232-f62051870736?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwZmluYW5jZSUyMGNvbnN1bHRhbnQlMjBtZWV0aW5nfGVufDB8fHx8MTc3NzYyMjUwOXww&ixlib=rb-4.1.0&q=85',
    alt: 'Finance consultant meeting with clients to review commercial lending options',
  },
};

export const getImageForPath = (path = '') => {
  if (path.includes('/truck')) return CATEGORY_IMAGES.truck;
  if (path.includes('/equipment')) return CATEGORY_IMAGES.equipment;
  if (path.includes('/vehicle')) return CATEGORY_IMAGES.vehicle;
  if (path.includes('/business-loans')) return CATEGORY_IMAGES.business;
  if (path.includes('/locations')) return CATEGORY_IMAGES.business;
  return CATEGORY_IMAGES.business;
};
